import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { isOrderReplaced } from "../../utils/orderInfo";
import { Bold } from "../common/Bold";
export var DamageMissingIA = function DamageMissingIA(_ref) {
  var context = _ref.context;
  var isReplacement = isOrderReplaced(context);
  if (isReplacement) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "LZxyBC",
      defaultMessage: [{
        "type": 0,
        "value": "Wanneer een retailer een artikel als ontbrekend of beschadigd opgeeft, ontvang je zowel een e-mail als een melding op de "
      }, {
        "children": [{
          "type": 0,
          "value": "pagina met bestelgegevens"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". In dit rapport vind je de artikelen en hoeveelheden die als ontbrekend of beschadigd zijn opgegeven. Je kan hier ook foto’s terugvinden van de artikelen die als beschadigd zijn opgegeven. Deze artikelen worden automatisch verwijderd van de factuur van de retailer."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder, _context$brandOrder$b;
          return _OrderLinkFormatting(chunks, (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "DpO7YM",
      defaultMessage: [{
        "type": 0,
        "value": "Als je denkt dat een retailer een artikel ten onrechte als ontbrekend of beschadigd heeft opgegeven, kun je het geschil betwisten."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "G5ytU0",
      defaultMessage: [{
        "type": 0,
        "value": "Wanneer je normaal de volgende dag wordt uitbetaald kun je rechtstreeks het geschil betwisten via het "
      }, {
        "children": [{
          "type": 0,
          "value": "probleemrapport"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " op de "
      }, {
        "children": [{
          "type": 0,
          "value": "pagina met bestelgegevens"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". Wanneer je een andere uitbetalingsoptie gebruikt kun je contact opnemen met ons supportteam voor meer hulp bij het betwisten van een geschil."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder2, _context$brandOrder2$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder2 = context.brandOrder) === null || _context$brandOrder2 === void 0 ? void 0 : (_context$brandOrder2$ = _context$brandOrder2.brand_order) === null || _context$brandOrder2$ === void 0 ? void 0 : _context$brandOrder2$.token);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "b3fCmJ",
      defaultMessage: [{
        "type": 0,
        "value": "Wanneer een retailer een artikel als ontbrekend of beschadigd opgeeft, ontvang je zowel een e-mail als een melding op de "
      }, {
        "children": [{
          "type": 0,
          "value": "pagina met bestelgegevens"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". In dit rapport vind je de artikelen en hoeveelheden die als ontbrekend of beschadigd zijn opgegeven. Je kan hier ook foto’s terugvinden van de artikelen die als beschadigd zijn opgegeven. Deze artikelen worden automatisch verwijderd van de oorspronkelijke factuur van de retailer en afgetrokken van je uitbetaling."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder3, _context$brandOrder3$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder3 = context.brandOrder) === null || _context$brandOrder3 === void 0 ? void 0 : (_context$brandOrder3$ = _context$brandOrder3.brand_order) === null || _context$brandOrder3$ === void 0 ? void 0 : _context$brandOrder3$.token);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+plhEc",
      defaultMessage: [{
        "type": 0,
        "value": "Als de retailer vervangende artikelen heeft aangevraagd, zie je automatisch een nieuwe bestelling op de pagina "
      }, {
        "children": [{
          "type": 0,
          "value": "Bestellingen"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ". Je ontvangt een aparte uitbetaling zodra je de nieuwe vervangende bestelling verwerkt."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "DpO7YM",
      defaultMessage: [{
        "type": 0,
        "value": "Als je denkt dat een retailer een artikel ten onrechte als ontbrekend of beschadigd heeft opgegeven, kun je het geschil betwisten."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "G5ytU0",
      defaultMessage: [{
        "type": 0,
        "value": "Wanneer je normaal de volgende dag wordt uitbetaald kun je rechtstreeks het geschil betwisten via het "
      }, {
        "children": [{
          "type": 0,
          "value": "probleemrapport"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " op de "
      }, {
        "children": [{
          "type": 0,
          "value": "pagina met bestelgegevens"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". Wanneer je een andere uitbetalingsoptie gebruikt kun je contact opnemen met ons supportteam voor meer hulp bij het betwisten van een geschil."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder4, _context$brandOrder4$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder4 = context.brandOrder) === null || _context$brandOrder4 === void 0 ? void 0 : (_context$brandOrder4$ = _context$brandOrder4.brand_order) === null || _context$brandOrder4$ === void 0 ? void 0 : _context$brandOrder4$.token);
        }
      }
    })));
  }
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Bold, null, chunks);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};